import {course_getCourseClasses_Api, course_getCourseClassesByOwner_Api} from 'apis'
import {getId} from 'apis/model/base'
import {createValue} from 'components/form/utils'
import React from 'react'
import ContainerPicker, {renderDefaultActions,} from 'views/AppLocals/custom/ContainerPicker'
import {AppEntities} from 'views/AppLocals/enums'
import {bindQueryParam, bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import {InnerWrapper, renderBaseOption} from '../../../../components/selectors/BaseSelector'
import useTranslate from "../../../../modules/local/useTranslate";
import {ItemInformation} from 'components/common/ItemInformation'
import {IdcodeTag} from 'components/common/IdcodeTag'

// course_id: khoanh vùng đúng 1 Khóa (dùng ở form Ban điều hành/Tạo lớp...). owner_id+owner_type
// (không kèm course_id): chọn lớp bất kỳ trong TOÀN BỘ tổ chức, không cần biết trước thuộc khóa nào -
// dùng ở nơi cần chọn "1 lớp" mà chưa đứng sẵn trong ngữ cảnh 1 khóa cụ thể (vd nút "Tạo & Phát Thông
// báo" ở dashboard Đào tạo & Huấn luyện, nhánh "Theo lớp cụ thể" - xem CourseNotificationsPanel.js).
// Chỉ 1 trong 2 chế độ áp dụng tuỳ props truyền vào, KHÔNG tạo component riêng trùng lặp UI.
export const CourseClassSelector = ({
  name,
  value,
  course_id,
  owner_id,
  owner_type,
  onChange = NullAsDefault,
  ...props
}) => {
    const t = useTranslate()
    const defaultValue = getId(value) ?? value

    return (
        <ContainerPicker
            name={name}
            allowClear={true}
            defaultValue={defaultValue}
            type={AppEntities.UNDEFINED}
            placeholder="click to select"
            renderInnerWrapper={InnerWrapper}
            renderActions={renderDefaultActions(value)}
            renderOption={renderBaseOption(defaultValue, (option) => ({
                title: (
                    <span className="flex items-center gap-1.5">
                        <IdcodeTag>{option?.course_class_idcode}</IdcodeTag>
                        <span className="truncate">{option?.title}</span>
                    </span>
                ),
                description: (
                    <ItemInformation
                        showIcon={true}
                        label="number of student"
                        value={`${option?.number_of_students} ${t('student')}`}
                        className="text-xs italic"
                    />
                ),
            }))}
            onOptionChange={(option) => {
                onChange(createValue(name, option ?? null))
            }}
            customConfigs={
                course_id
                    ? {
                        apiInfo: course_getCourseClasses_Api,
                        query: bindQueryParam({id: course_id}),
                    }
                    : {
                        apiInfo: course_getCourseClassesByOwner_Api,
                        query: bindQueryParams([{type: owner_type}, {id: owner_id}]),
                    }
            }
            {...props}
        />
    )
}
